export const MarketPaths = {
	Index: {
		route: "/markets",
		path: "/markets",
	},
	EditGeneral: {
		route: "/markets/edit/:urlPath?/general",
		path: (urlPath: string) => `/markets/edit/${urlPath}/general`,
	},
	EditRegions: {
		route: "/markets/edit/:urlPath?/regions",
		path: (urlPath: string) => `/markets/edit/${urlPath}/regions`,
	},
	EditEmails: {
		route: "/markets/edit/:urlPath?/emails",
		path: (urlPath: string) => `/markets/edit/${urlPath}/emails`,
	},
	OrderImport: {
		route: "/markets/edit/:urlPath?/order-import",
		path: (urlPath: string) => `/markets/edit/${urlPath}/order-import`,
	},
	Create: {
		route: "/markets/create",
		path: "markets/create",
	},
	Select: {
		route: "/markets/select",
		path: "/markets/select",
	},
};
